module.exports = require('buffer')



//////////////////
// WEBPACK FOOTER
// ./~/safe-buffer/browser.js
// module id = 111
// module chunks = 4